import React from 'react';
import { Summary } from 'src/features/MM/components/templates/Summary';
import { Page } from '../../components/molecules/Page';
import { FilterBar } from '../../components/organisms/FilterBar';
import { GenAIActionButtons } from 'src/components/molecules/GenAIActionButtons';

export const SummaryPage: React.FC = () => {
  return (
    <Page
      pageTitle="Summary"
      pageSubtitle="Track your project and goal with full information"
      filterBar={<FilterBar includeAggregation={false} includeDimension />}
      extraButtons={<GenAIActionButtons />}>
      <Summary />
    </Page>
  );
};
